import { createSlice } from "@reduxjs/toolkit";
import { getRoleByStatus } from "../../api/role";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getRoleByQuerySlice = createSlice({
  name: "getRolesByStatus",
  initialState: data,
  reducers: {
   getRoleByQuerySlice(state) {
      state.isLoading = true;
    },
   getRoleByQuerySliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getRoleByQuerySliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getRoleByQuerySliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});

export const getRoleByQueryHandler = (data: any) => async (dispatch: any) => {
  try {
    dispatch(getRoleByQueryIdAction.getRoleByQuerySlice());
    const response: any = await getRoleByStatus(data);
    
    dispatch(getRoleByQueryIdAction.getRoleByQuerySliceSuccess(response));
  } catch (e: any) {
    dispatch(getRoleByQueryIdAction.getRoleByQuerySliceFailure(e?.response?.data));
  }
};

export default getRoleByQuerySlice.reducer;
export const getRoleByQueryIdAction = getRoleByQuerySlice.actions;
